import { render } from "./ChooseCNGBrands.vue?vue&type=template&id=1b4241fc"
import script from "./ChooseCNGBrands.vue?vue&type=script&lang=js"
export * from "./ChooseCNGBrands.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__